import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

import { ProcurosOnlyBadge } from './ProcurosOnlyBadge';

type ProcurosOnlyBannerProps = {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
};

/**
 * Marks a block of content as visible to Procuros members only. Everything inside is internal:
 * never wrap partner-visible copy in it, and never render it for content the API also returns to
 * non-admin users. The banner always renders the shared ProcurosOnlyBadge with its standard text and
 * exposes no way to relabel or remove it — that marking is the whole reason the component exists.
 */
export const ProcurosOnlyBanner = ({ title, children, className }: ProcurosOnlyBannerProps) => {
  return (
    <div className={cn('w-full rounded-md bg-orange-50 p-4', className)}>
      <div className="flex items-start gap-3">
        {title ? (
          <p className="min-w-0 text-sm leading-5 font-semibold wrap-break-word text-orange-700">{title}</p>
        ) : null}
        <ProcurosOnlyBadge variant="white" className="ml-auto" />
      </div>
      <div className="mt-1 text-sm leading-5 wrap-break-word text-gray-900">{children}</div>
    </div>
  );
};
